import React, {useEffect, useReducer, useState} from 'react';
import {Switch, withStyles} from '@material-ui/core';
import * as Styles from './styles';

import ModalConfirmacao from '../../../../../components/Modal/ModalConfirmacao/ModalConfirmacao';
import {ReactSelectCheckbox} from '../../../../../components/Select/SelectSearch';

import {weekDays} from '../../../TransferenciaAgendamento/constants';
import {combineDayHourPairs} from './utils/utils';
import {
    updateProcedimentosConfiguracaoHorarioAtendimento
} from '../../../../../services/ConfiguracaoHorarioAtendimentoService';
import {observer} from 'mobx-react-lite';
import {inject} from 'mobx-react';


const ConfigAgendamentosOnlineModal = observer(({
  classes,
  isOpen,
  diaSemana,
  horaInicio,
  horarios,
  onClose,
  currentConfigVigente,
  configuracaoHorarioAtendimentoStore,
}) => {
  const [horariosOptions, setHorariosOptions] = useState([]);
  const [diaSemanaOptions, setDiaSemanaOptions] = useState([]);
  const [isLoading, toggleLoading] = useReducer((state) => !state, false);
  const [permiteAgendamentoOnlineChecked, setPermiteAgendamentoOnlineChecked] = useState(true);

  const handleChangeWeekDay = (selectedsDays) => {
    const updatedWeekDays = diaSemanaOptions.map((item) => ({
      ...item,
      checked: checkIsSelected(item, selectedsDays),
    }));
    setDiaSemanaOptions(updatedWeekDays);
  };

  const handleChangeHours = (selectedHours) => {
    const updatedHours = horariosOptions.map((item) => ({
      ...item,
      checked: checkIsSelected(item, selectedHours),
    }));
    setHorariosOptions(updatedHours);
  };

  const checkIsSelected = (item, list) => {
    return list.some((option) => option.value === item.value);
  };

  const handleSaveConfig = async () => {
    const selectedsDays = diaSemanaOptions.filter((item) => item.checked);
    const selectedHours = horariosOptions.filter((item) => item.checked);
    const weekDayHourPairs = combineDayHourPairs(selectedsDays, selectedHours);
    let horariosAtendimento = currentConfigVigente.horariosAtendimento || [];

    weekDayHourPairs.forEach((item) => {
      const { diaSemana, horaInicio } = item;
      const indexToUpdate = horariosAtendimento.findIndex(
        (config) =>
          config.diaSemana === diaSemana && config.horaInicio === horaInicio
      );

      if (
        indexToUpdate > -1 &&
        horariosAtendimento[indexToUpdate]?.permiteAgendamento
      ) {
        horariosAtendimento[indexToUpdate].permiteAgendamentoOnline = permiteAgendamentoOnlineChecked;
      }
    });

    const newConfigVigente = {
      ...currentConfigVigente,
      horariosAtendimento,
    };
    onSaveConfig(newConfigVigente);
  };

  const handleToggle = () => {
    setPermiteAgendamentoOnlineChecked(!permiteAgendamentoOnlineChecked);
  };

  const onSaveConfig = async (newConfigVigente) => {
    try {
      const id = window.location.hash.split('/')[3];
      toggleLoading();
      await updateProcedimentosConfiguracaoHorarioAtendimento(newConfigVigente);
      await configuracaoHorarioAtendimentoStore.getConfigById(id);
      onClose({ isReloadingConfig: true });
    } catch (error) {
      console.error(error);
    } finally {
      toggleLoading();
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    const horariosOptions = horarios?.map((item) => ({
      value: item,
      label: item,
      checked: item === horaInicio || false,
    }));
    const diasSemanaOptions = weekDays.map((item) => ({
      value: item.value,
      label: item.nome,
      checked: item.value === diaSemana || false,
    }));
    setHorariosOptions(horariosOptions || []);
    setDiaSemanaOptions(diasSemanaOptions || []);
  }, [isOpen]);

  if (!isOpen) return null;

  const buttonsConfig = {
    labelPrimaryButton: 'Cancelar',
    handlePrimaryButton: onClose,
    disabledPrimaryButton: isLoading,
    labelSecondButton: 'Salvar',
    handleSecondButton: handleSaveConfig,
    disabledSecondButton: isLoading,
    loadingSecondButton: isLoading,
  };

  return (
    <ModalConfirmacao
      classes={{ paperAlert: classes.paperAlert }}
      open={isOpen}
      buttons={buttonsConfig}
      title='Configurações'
      idPrimaryButton='cfg-cao-btn-can'
      idSecondButton='cfg-cao-btn-sal'
    >
      <Styles.Container>
        <Styles.InputContainer>
          <Styles.Label>Permitir agendamento online</Styles.Label>
          <Switch id='cfg-cao-swt-per' color='primary' checked={permiteAgendamentoOnlineChecked} onChange={handleToggle} />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Dias da Semana</Styles.Label>
          <ReactSelectCheckbox
            id='cfg-cao-sel-dia'
            options={diaSemanaOptions}
            value={diaSemanaOptions.filter((item) => item.checked)}
            onChange={handleChangeWeekDay}
          />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Horários</Styles.Label>
          <ReactSelectCheckbox
            id='cfg-cao-sel-hor'
            options={horariosOptions}
            value={horariosOptions.filter((item) => item.checked)}
            onChange={handleChangeHours}
          />
        </Styles.InputContainer>
      </Styles.Container>
    </ModalConfirmacao>
  );
});

const stores = ["configuracaoHorarioAtendimentoStore"]
const ConfigAgendamentosOnlineModalWithStyles = withStyles(Styles.styles)(ConfigAgendamentosOnlineModal);
export default inject(stores)(ConfigAgendamentosOnlineModalWithStyles)
